<section class="breadcrumb-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-title">
          <h1>Sports</h1>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-lg std-scholarship">
  <div class="container">
    <div class="row row-50 justify-content-center">
      <div class="col-lg-10">
        <iframe src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisonimain/sports.mp4?autoplay=1&amp;mute=1"
          allow="autoplay" width="100%" height="400px" frameborder="0"></iframe>
      </div>
      <div class="col-md-3">
        <div class="vertical-tabs mt-5">
          <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="tab1-tab" data-toggle="tab" href="#tab1" role="tab" aria-controls="tab1"
                aria-selected="true">Overview</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab2-tab" data-toggle="tab" href="#tab2" role="tab" aria-controls="tab2"
                aria-selected="false">Shaurya Indoor Sports</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab3-tab" data-toggle="tab" href="#tab3" role="tab" aria-controls="tab3"
                aria-selected="false">Raisoni premier league (RPL)</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab4-tab" data-toggle="tab" href="#tab4" role="tab" aria-controls="tab4"
                aria-selected="false">Raisoni Badminton Super Series</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="tab5-tab" data-toggle="tab" href="#tab5" role="tab" aria-controls="tab5"
                aria-selected="false">Super Seven Cricket National League</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-md-9">
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="tab1" role="tabpanel" aria-labelledby="tab1-tab">
            <div class="inner-title" >
              <h3>Overview</h3>
             
            </div>
            <div class="text-justify" >
              <blockquote>“Sports teaches you character, it teaches you to play by the rules, it teaches you to know
                what it feels like to win and lose-it teaches you about life.”- Billie Jean King</blockquote>
              <p>Inevitably Sports and Games make an indispensable part of the curriculum of our educational institutes.
                They are the carrier of a healthy mind, a healthy body and a free soul. They aid in the development of
                social skills. They reduce stress. They make sure that co-operation and coordination becomes the part
                and parcel of the lives of the student</p>
              <h5>The attributes we eye on</h5>
              <ul class="list-item">
                <li>An environment which motivates students</li>
                <li>An optimism which never ceases to enlighten their lives</li>
                <li>The team work which nurtures them on every track</li>
                <li>The sportsman spirit which once ingested never leaves them</li>
              </ul>
              <p>As the pioneer institute providing holistic education, we have the best sports facility with us to take
                care of all of the above.</p>
              <h5>Our sports facilities</h5>
              <p>Here are some key pointers describing them well:-</p>
              <ul class="list-item">
                <li><strong>Outdoor games -</strong> Outdoor games like badminton, football, basketball, and cricket
                  have specifications with respect to the field needs. We have it all on our campus. We make sure to
                  provide with amenities which are best in the class to provide the students with unsurpassed playing
                  experience right here in our fields.</li>
                <li><strong>Indoor games -</strong> Finest of the indoor games facilities lie with our institute. We
                  have table tennis, chess, and carom as the part of the indoor sports activities for our students. The
                  students can spend their time in engaging in the sports arena of our indoor games with ease.</li>
                <li><strong>Sports in charge -</strong> We do comprehend the need of sports in charge in every sport.
                  Thus, we have appointed the teachers for both indoor and outdoor game to guide the aspiring sports
                  person well. They are excellent in their field. They have complete knowledge about the rules and
                  regulations. We do have a sports coordinator in each class to encourage the students.</li>
                <li><strong>Competitions -</strong> In order to inculcate a sportsman spirit in the students, time and
                  again sports competition are held in the college. There are held the inter class competitions. And,
                  there are also organized the Intercollegiate sports meet. This inspires the students, enables them
                  knowledge about the level of competition and prepares them for future endeavors.</li>
                <li><strong>First aid box -</strong> Complete care is taken at the college premises to keep it safe for
                  the students playing sports. However, if during some sports event or regular games a student gets hurt
                  the sports facility has the first aid box to aid them with medical assistance.</li>
                <li><strong>Sports dignitaries -</strong> The best sportsperson in the various sports, the sports
                  personality, those that have made the nation proud with their milestone achievements are a treasure to
                  the society. In order to inculcate the students with supreme aims, they are invited by our institute
                  to give lectures about the games.</li>
              </ul>
              <p>Fitness of body, mind and soul is the vision we have for our students at our institute.</p>
              <blockquote>Play well! Live well! Stay healthy!</blockquote>
            </div>
          </div>

          <div class="tab-pane fade" id="tab2" role="tabpanel" aria-labelledby="tab2-tab">
            <div class="inner-title" >
              <h3>Shaurya Indoor Sports
              </h3>
             
            </div>
            <div class="text-justify" >
              <p>The College encourages Indoor Sports activities for all round development of the students. The
                activities comprises of Chess Competition, Carom, Pool Table, Table Tennis and Badminton. The Students
                are participates in various competition held under each activity. The College has best of the equipments
                and instructor to teach the students with perfection. The winners are awarded with trophy and
                certificate.</p>
            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/shorya-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/shorya-1.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/shorya-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/shorya-2.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/shorya-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/shorya-3.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/shorya-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/shorya-4.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/shorya-5.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/shorya-5.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="tab-pane fade" id="tab3" role="tabpanel" aria-labelledby="tab3-tab">
            <div class="inner-title" >
              <h3>Raisoni premier league (RPL)
              </h3>
             
            </div>
            <div class="text-justify" >
              <p>The familiar quote “All work and no play makes Jack a dull boy” of yester years has gain much
                importance in today’s scenario. Sports in any form indoor or outdoor are played by the youth of today,
                but only on smartphones. Taking to playgrounds, bruising your knees, giving your stamina a test is yet
                to see its own sunrise.</p>
              <p>Keeping in mind all this, our College had sown seeds of RPL an intra-college cricket tournament for its
                Bachelor of Business Administration (BBA) & Bachelor of Commerce – Computer Application (BCCA) students
                in the year 2013. Since then there was no looking back. The seeds sown have taken the shape of a huge
                tree imparting its shadow and fruits to all the budding young graduates of our College who feel sports
                can be taken up as professional career.</p>
              <p>We have been inspired from Indian Premier League (IPL) and have made efforts to conduct RPL on the same
                lines. Right from auction of students to faculty members being made as team owners to conducting league
                matches and getting best of the sports personalities on this platform has been our sole aim and mission
                behind this gala event. We were fortunate to have ex cricketers like Prashant Vaidya, Subrato Bannerjee
                to the present ones like Faiz Fazal to name a few on this platform. Their presence acted as a motivating
                factor to our students and efficiency barometer of our students scaled new heights. Attached here with
                are few images for yesteryears which will remain in your cherished memory for years to come.</p>
            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-1.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-2.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-3.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-4.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-5.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-5.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-6.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-6.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-7.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-7.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/rpl-8.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/rpl-8.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab4" role="tabpanel" aria-labelledby="tab4-tab">
            <div class="inner-title" >
              <h3>Raisoni Badminton Super Series
              </h3>
             
            </div>
            <div class="text-justify" >
              <p>G H Raisoni College of Commerce Science & Technology has organizing one day event that is Raisoni
                Badminton Super Series for the students of BBA & BCCA, every year in Sports Department, Shraddha House,
                Nagpur. We are honored that we got this opportunity to contribute in Sports activity. The motive of this
                tournament program was to inculcate sports qualities and physical fitness. This initiative was taken by
                the college to make the student active towards participation in sports. Also it gave help to the
                students for their exposure in nonacademic activities. Students are motivated by giving cash prizes and
                certificates.</p>
            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/batminton-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/batminton-1.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/batminton-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/batminton-2.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/batminton-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/batminton-3.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/batminton-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/batminton-4.webp" alt="Sports | Ghrcacsn" title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tab5" role="tabpanel" aria-labelledby="tab5-tab">
            <div class="inner-title" >
              <h3>Super Seven Cricket National League
              </h3>
             
            </div>
            <div class="text-justify" >
              <p>G. H. Raisoni College of Commerce, Science and Technology Nagpur’s students got selected in Super Seven
                Cricket National League which was held in Jammu on 18th Nov 2021. Trials of this event were conducted in
                Yashwant stadium, Nagpur in front of officials of Super Seven Cricket League. National camp trials were
                successfully conducted by Ajay Hiwarkar, President of Vidarbha Super Seven Cricket League. Team achieved
                2nd place in Jammu National </p>
              <p> In this tournament following students & coach got selected:</p>
              <ul class="list-item link-list">
                <li>Arpit Mande</li>
                <li>Tanshiq chhajer</li>
                <li>Aditiya Kaushal</li>
                <li>Jay sahajwani</li>
                <li>Dev sahajwani</li>
                <li>Parth kopulwar</li>
                <li>Mustafa Surat</li>
                <li>Dhruv Gaidhane</li>
                <li>Dr. Vivek Sahu (Coach)</li>
              </ul>
              <p>Dr. Vivek Sahu inspired & motivated his team. Students & coaches got incredible support from Dr. Aarti
                Deshpande (Director), Dr. Jasvinder Kaur (Principal)</p>
            </div>
            <div class="row mb-20">
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/super-seven-cricket-1.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/super-seven-cricket-1.webp" alt="Sports | Ghrcacsn"
                      title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/super-seven-cricket-2.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/super-seven-cricket-2.webp" alt="Sports | Ghrcacsn"
                      title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/super-seven-cricket-3.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/super-seven-cricket-3.webp" alt="Sports | Ghrcacsn"
                      title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
              <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                  <a href="assets/images/gallery/super-seven-cricket-4.webp" data-lightbox="example-set"
                    data-title="GHRCCST GALLERY GLIMPSES">
                    <img class="img-fluid" src="assets/images/gallery/super-seven-cricket-4.webp" alt="Sports | Ghrcacsn"
                      title="Sports | Ghrcacsn">
                    <div class="gallery-overlay"></div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>